module.exports = __webpack_public_path__ + "static/media/p6_3.39476987.png";